export const smokypurples = {
  name: 'Smoky Purples',
  color: [0.4470588235294118, 0.4392156862745098, 0.4666666666666667, 1],
  bg: [0.7372549019607844, 0.7294117647058823, 0.7450980392156863, 1],
  grid1: [0.9333333333333333, 0.8470588235294118, 0.788235294117647, 1],
  grid2: [0.9137254901960784, 0.592156862745098, 0.5294117647058824, 1],
}
